export default __webpack_public_path__ + "static/media/MundialRegular.6463abd8.otf";